import { render } from "./WarningCountdown.vue?vue&type=template&id=2779220e"
import script from "./WarningCountdown.vue?vue&type=script&lang=js"
export * from "./WarningCountdown.vue?vue&type=script&lang=js"

import "./WarningCountdown.vue?vue&type=style&index=0&id=2779220e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__